<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <paginated-table :id="$attrs['id']"
                   :items-per-page="itemsPerPage"
                   :rows="folios"
                   :hover="false"
                   columns="4"
                   grid-template-columns="max-content auto max-content 6rem"
                   min-width="500px">
    <template slot="table-head">
      <div class="hm-table__th">{{ $t('table.transferFolioTable.folioNumber') }}</div>
      <div class="hm-table__th">{{ $t('table.transferFolioTable.invoiceRecipient') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transferFolioTable.balance') }}</div>
      <div class="hm-table__th text-right"></div>
    </template>
    <template v-slot:default="slotProps">
      <template v-for="folio in slotProps.currentPage">
        <div :class="[{'hm-table__td--drop': dropTarget === folio.id}]"
             class="hm-table__td"
             @dragenter="dragenter($event, folio)"
             @dragleave="dragleave($event, folio)"
             @dragover="dragover($event, folio)"
             @drop="drop($event, folio)">{{ folio.number + 1 }}</div>
        <div :class="[{'hm-table__td--drop': dropTarget === folio.id}]"
             class="hm-table__td privacy--blur"
             @dragenter="dragenter($event, folio)"
             @dragleave="dragleave($event, folio)"
             @dragover="dragover($event, folio)"
             @drop="drop($event, folio)">{{ folio.address }}</div>
        <div :class="[{'color--red': folio.balance < 0}, {'hm-table__td--drop': dropTarget === folio.id}]"
             class="hm-table__td text-right"
             @dragenter="dragenter($event, folio)"
             @dragleave="dragleave($event, folio)"
             @dragover="dragover($event, folio)"
             @drop="drop($event, folio)">{{ folio.balance | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div :class="[{'hm-table__td--drop': dropTarget === folio.id}]"
             class="hm-table__td text-right hm-table__td--icon"
             @dragenter="dragenter($event, folio)"
             @dragleave="dragleave($event, folio)"
             @dragover="dragover($event, folio)"
             @drop="drop($event, folio)">
          <span v-tooltip="{ title: $t('table.transferFolioTable.pullAllTranasactions'), delay: 250, placement: 'left', positionFixed: true, trigger: 'hover', touch: false }"
                v-if="folio.hasAnyTransactions"
                class="quick-action-button"
                @click="transferIn(folio.id)">
            <icon icon="forward-2c" />
          </span>
        </div>
      </template>
    </template>
  </paginated-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last, sumBy } from 'lodash';
import PaginatedTable from './PaginatedTable';
import FolioTable from './FolioTable';

export default {
  name: 'TransferFolioTable',
  extends: FolioTable,
  mixins: [HotelmeisterMixin],

  props: {
    parentId: {
      type: String,
      required: true,
    },
    folioId: {
      type: String,
      required: true,
    },
    balance: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data: function () {
    return {
      dropTarget: null,
    };
  },

  created: function () {
    this.$serviceBus.$on('transaction.dragend', () => {
      this.dropTarget = null;
    });
  },

  methods: {
    dragleave($event, folio) {
      if (this.dropTarget === folio.id) {
        this.dropTarget = null;
        this.$serviceBus.$emit('transaction.dragleave');
        $event.dataTransfer.dropEffect = 'none';
      }
      $event.stopPropagation();
    },
    drop($event, folio) {
      this.dropTarget = null;
      const srcTransaction = JSON.parse($event.dataTransfer.getData('text/plain'));
      if (!isEmpty(srcTransaction.transactionId) && !isEmpty(srcTransaction.parentId) && !isEmpty(srcTransaction.folioId)) {
        if (srcTransaction.folioId === folio.id && srcTransaction.parentId === this.parentId) {
          this.showSuccessMessage();
          return;
        }

        if (this.$store.getters['save/saveInProgress']) return;

        this.$store.commit('save/started', this.folioId);
        this.axios.put(this.serviceUrls.folio.transferTransaction(this, srcTransaction.parentId, srcTransaction.folioId, srcTransaction.transactionId), { parentId: this.parentId, folioId: folio.id })
          .then((response) => {
            this.$serviceBus.$emit('folio.reload');
            this.$emit('transferred');
            this.showSuccessMessage();
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .finally(() => {
            this.$store.commit('save/finished', this.folioId);
          });
      }
    },
    dragover($event, folio) {
      if (folio.id !== this.dropTarget) {
        if (isEmpty(folio.invoiceNumber) && folio.locked !== true) {
          this.dropTarget = folio.id;
          $event.dataTransfer.dropEffect = 'move';
          this.$serviceBus.$emit('transaction.dragenter');
        } else {
          $event.dataTransfer.dropEffect = 'none';
        }
      }
      $event.stopPropagation();
      $event.preventDefault();
    },
    dragenter($event, folio) {
      if (isEmpty(folio.invoiceNumber) && folio.locked !== true) {
        this.dropTarget = folio.id;
        $event.dataTransfer.dropEffect = 'move';
        this.$serviceBus.$emit('transaction.dragenter');
      } else {
        $event.dataTransfer.dropEffect = 'none';
      }
      $event.stopPropagation();
    },
    transferIn(folioId) {
      this.$emit('transferin', { folioId: folioId, parentId: this.parentId });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/TransferFolioTable.vue